import { BrandColorItem } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";
import { BrandColorFields, brandColorsUrl } from "./cmdGetBrandColors";

export class CommandCreateBrandColor {
    async run(organizationId: string, brandId: string, fields: BrandColorFields): Promise<BrandColorItem> {
        return await httpRequest<BrandColorItem>(brandColorsUrl(organizationId, brandId), { method: "POST", body: fields });
    }
}
